export default "__VITE_ASSET__2ca4fc13__"